import {BaseService, Body, DELETE, GET, Headers, Path, POST, Query, QueryMap, Response} from 'ts-retrofit';
import {ACCEPT_JSON} from '../../config';
import {MovieGenre} from '../../../../models/vision/movie';
import {ToData} from '../../rest-api-hydratator-decorators';
import {User} from '../../../../models/user';

const base = 'genres';

export class MovieGenresApiService extends BaseService {
  @GET(`/${base}`)
  @Headers({...ACCEPT_JSON})
  @ToData(MovieGenre)
  async getGenres(): Promise<Response<MovieGenre[]>> {
    return <Response>{};
  }

  @GET(`/${base}/{id}`)
  @Headers({...ACCEPT_JSON})
  @ToData(MovieGenre)
  async byId(@Path('id') id: number): Promise<Response<MovieGenre>> {
    return <Response>{};
  }

  @POST(`/${base}`)
  @Headers({...ACCEPT_JSON})
  @ToData(MovieGenre)
  async saveGenre(@Body genre: MovieGenre): Promise<Response<MovieGenre>> {
    return <Response>{};
  }

  @DELETE(`/${base}/{id}`)
  @Headers({...ACCEPT_JSON})
  async deleteGenre(@Path('id') id: number): Promise<Response<void>> {
    return <Response>{};
  }
}
